import { render, staticRenderFns } from "./TrialPatientReminderNotification.vue?vue&type=template&id=df89ceea&scoped=true&"
import script from "./TrialPatientReminderNotification.vue?vue&type=script&lang=js&"
export * from "./TrialPatientReminderNotification.vue?vue&type=script&lang=js&"
import style0 from "./TrialPatientReminderNotification.vue?vue&type=style&index=0&id=df89ceea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df89ceea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VRow})
